import React from "react";
import Text from "@components/shared/text";
import Link from "@components/shared/linkNoPrefetch";
import styles from "./style.module.scss";
import LocationIcon from "./icons/locationIcon";
import NetworkIcon from "./icons/networkIcon";
import HomeIcon from "./icons/homeIcon";
import EmailIcon from "./icons/emailIcon";
import PhoneIcon from "./icons/phoneIcon";
import { translate } from "@helpers/translationObjectFormatter";
import { TranslationsObject } from "@genericTypes/sharedTypes";
import { useQuery } from "@tanstack/react-query";
function Map() {
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);

    return (
        <div className="lg:mt-48 lg:mb-52 my-20 flex lg:flex-row flex-col justify-between gap-12">
            <div className="lg:w-[65%] w-full h-[400px] lg:h-auto">
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3067.4186385311054!2d-75.53142742353538!3d39.752708095785714!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c6fd32f02dfad1%3A0xe6f2b1c677ee067e!2s2810%20N%20Church%20St%2C%20Wilmington%2C%20DE%2019802%2C%20USA!5e0!3m2!1sen!2sjo!4v1702542159279!5m2!1sen!2sjo"
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    loading="lazy"
                    // eslint-disable-next-line react/no-unknown-property
                    allowFullScreen
                ></iframe>
            </div>
            <div className=" lg:w-[35%] w-full text-center lg:text-start pb-5">
                <Text className="font-extrabold lg:text-3xl lg:leading-[45px]  mt-14 ">
                    {translate(
                        translations,
                        "several_contactUsPage_mapMainTitle",
                    )}
                </Text>

                <div className=" w-fit mx-auto lg:w-auto">
                    <div className="mt-11  flex gap-4 items-center">
                        <span>
                            <NetworkIcon />
                        </span>
                        <Link
                            href="/"
                            className={`${styles["linkColor"]} underline font-bold lg:text-xl lg:leading-5`}
                        >
                            Several.com
                        </Link>
                    </div>
                    <div className="mt-6 flex gap-4 items-center">
                        <span>
                            <LocationIcon />
                        </span>
                        <div className="lg:text-xl lg:leading-5">
                            2810 N Church St #56440
                        </div>
                    </div>
                    <div className="mt-6 flex gap-4 items-center">
                        <span>
                            <HomeIcon />
                        </span>
                        <div className="lg:text-xl lg:leading-5">
                            Wilmington, DE 19802
                        </div>
                    </div>
                    <div className="mt-6 flex gap-4 items-center">
                        <span>
                            <EmailIcon />
                        </span>
                        <div className="lg:text-xl lg:leading-5">
                            {`${translate(
                                translations,
                                "several_contactUS_formPlaceHolderEmail",
                            )}:`}
                            <Link href="mailto:info@several.com">
                                info@several.com
                            </Link>
                        </div>
                    </div>
                    <div className="mt-6 flex gap-4 items-center">
                        <span>
                            <PhoneIcon />
                        </span>
                        <div className="lg:text-xl lg:leading-5">
                            {`${translate(
                                translations,
                                "several_contactUS_formPlaceHolderPhone",
                            )}:`}
                            <span className={styles["phoneNumberDirection"]}>
                                <Link href="tel:+12817778404">
                                    +1 (281) 777-8404
                                </Link>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Map;
